import { useLocation } from 'react-router-dom';

import GoogleAnalyticsReporter from '@/components/Analytics/GoogleAnalyticsReporter';
import { useMediaQueryDevice } from '@/components/MediaQuery';
import TermModal from '@/components/TermModal';

import EnableAgentModal from '@/features/agent/EnableAgentModal';
import MintToaster from './components/MintToaster';
import GlobalWalletModal from './components/WalletStatus/GlobalWalletModal';
import PortfolioPageConnectionCheck from './mobile/PortfolioMobile/PortfolioPageConnectionCheck';
import BlastWithdrawModal from './portfolio/BlastWithdraw/BlastWithdrawModal';
import { useBlastWithdraw } from './portfolio/BlastWithdraw/useBlastWithdraw';

export default function GlobalComponent(): JSX.Element {
  const { isMobile } = useMediaQueryDevice();
  const location = useLocation();
  const { isOpen: isBlastWithdrawOpen, onClose: onCloseBlastWithdraw, balances: blastBalances } = useBlastWithdraw();

  return (
    <>
      {/* <InitialNetworkSwitchModal /> */}
      <TermModal />
      {/* <GlobalNetworkModal /> */}
      <GlobalWalletModal />
      <GoogleAnalyticsReporter />
      {isMobile && !location.pathname.includes('blocker') && <MintToaster />}
      {isMobile && <PortfolioPageConnectionCheck />}
      <EnableAgentModal />
      <BlastWithdrawModal open={isBlastWithdrawOpen} onClose={onCloseBlastWithdraw} balances={blastBalances} />
    </>
  );
}
